<template>
  <div class="container">
    <div class="navbar">
      <div class="search">
        <input v-bind:placeholder="$t('search')" @click="openAutocomplete" class="search__input" id="autocomplete" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" type="text">
        <div class="search__icon"></div>
      </div>
      <Position />
  </div>

  </div>
</template>

<script>
  import { EventBus } from '@/bus'
  import Position from './PositionButton'

  export default {
    name: 'Search',
    components: {
      Position
    },
    data: () => ({
      autocomplete: null
    }),
    methods: {
      openAutocomplete () {
        document.getElementsByClassName('pac-container')[0].style.display = 'block'
      }
    },
    mounted () {
      EventBus.$on('googleReady', () => {
        this.autocomplete = new google.maps.places.Autocomplete((document.getElementById('autocomplete')), {types: []})
        this.autocomplete.addListener('place_changed', () => {
          EventBus.$emit('autocomplete', this.autocomplete.getPlace())
        })
      })
    }
  }
</script>

<style lang="scss" scoped>
  .container {
    background-color: #F9F9F9;
    z-index: 8;
    box-shadow: 0 0 10px rgba(0, 0, 0, .2);
  }
  .navbar {
    display: flex;
    align-items: center;
    height: 3.6rem;
    flex: 1 1 auto;
  }
  .search {
    position: relative;
    flex: 1;
    height: 100%;
  }
  .search__input {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0 2.4rem 0 1.6rem;
    z-index: 1;
    border: 0;
    box-sizing: border-box;
    font-size: 1.2rem;
    text-overflow: ellipsis;
  }
  .search__input:focus {
    outline: 0;
    border: 1px solid #17212F;
    border-top: 0;
    border-bottom-color: #EEE;
    box-shadow: 0 1px 10px rgba(0, 0, 0, .3);
  }
  .search__icon {
    position: absolute;
    top: calc(50% - 9px);
    right: 18px;
    width: 18px;
    height: 18px;
    background-image: url('/static/images/search.png');
    background-size: 18px;
    z-index: 10;
  }
</style>

<style src="@/styles/autocomplete.scss" lang="scss"></style>



// WEBPACK FOOTER //
// Search.vue?6c15f7b8